<template>
  <PageWrap :page-title="pageTitle">
    <LoadingIndicator
      v-if="loadingData"
      class="mt-5"
    />

    <template v-else>
      <b-row>
        <b-col cols="8">
          <RetainedForm
            :data="formData"
            :errors="formErrors"
            :editing="isEditing"
            :assessor-select-options="assessorOptions"
            :type-select-options="typeOptions"
            @update="updateForm"
          />
        </b-col>
      </b-row>

      <div v-if="!isEditing" class="mt-4">
        <BfButton @click="storeRetenido">Guardar</BfButton>
      </div>
    </template>
  </PageWrap>
</template>

<script>
import RetainedForm from '@/components/FormGroups/RetainedForm';
import LoadingIndicator from '@/components/LoadingIndicator';
import PageWrap from '@/components/PageWrap';
import { chargeAPI, retainedsAPI } from '@/api';
import get from 'lodash.get';
import { mapState } from 'vuex';

export default {
  name: 'RetainedDetail',

  props: {
    id: {
      type: String,
    },
  },

  data() {
    const { chargeId = '' } = this.$route.query;

    return {
      chargeId,
      formData: {},
      formErrors: {},
      loadingData: false,
      retenido: {},
      assessorOptions: [],
      typeOptions: [],
    };
  },

  async created() {
    this.loadingData = true;

    try {
      if (this.isEditing) {
        await this.loadData();
      } else {
        if (!!this.chargeId === false) {
          this.$router.replace({ name: 'retenidos' });
        }

        await this.prepareForm();
        await this.getChargeData();
      }
    } finally {
      this.loadingData = false;
    }
  },

  methods: {
    async storeRetenido() {
      this.formData.tasador_abre_id = this.tasadorId;
      this.formData.encargos_id = this.chargeId;

      try {
        this.formErrors = {};
        const { data, message } = await retainedsAPI.create(this.formData);
        this.$bfNotify({ title: 'Guardado', message, type: 'success' });
        this.$router.replace({ name: 'retenido', params: { id: `${data.id}` } });
      } catch ({ errors, message }) {
        this.formErrors = errors;
        this.$bfNotify({ title: 'Error', message, type: 'error' });
      }
    },

    async loadData() {
      const { data, tasadores, tipos } = await retainedsAPI.get(this.id);

      this.formData = data;
      this.setAssessorOptions(tasadores);
      this.setTypeOptions(tipos);
    },

    async prepareForm() {
      const { data, tasadores, tipos } = await retainedsAPI.preCreate();

      this.formData = { ...this.formData, ...data };
      this.setAssessorOptions(tasadores);
      this.setTypeOptions(tipos);
    },

    async getChargeData() {
      if (this.chargeId) {
        const {
          data: [charge],
        } = await chargeAPI.get(this.chargeId);

        this.formData = {
          ...this.formData,
          encargo_numero: charge.numero_encargo,
          encargo_cliente_nombre: charge.empresa_cliente_nombre,
          encargo_expediente: charge.expediente,
        };
      }
    },

    setAssessorOptions(data) {
      if (data) {
        this.assessorOptions = data.map(({ clave, id }) => ({ label: clave, value: id }));
      }
    },

    setTypeOptions(data) {
      if (data) {
        this.typeOptions = data.map(type => ({ label: type, value: type }));
      }
    },

    async updateForm({ key, value }) {
      const newData = { [key]: value };

      if (key === 'externo' && value) {
        newData.tasador_asignado_id = null;
      }

      if (key === 'tasador_asignado_id' && value) {
        newData.externo = false;
      }

      if (!this.isEditing) {
        this.formData = { ...this.formData, ...newData };
      } else {
        this.formErrors = {};

        try {
          const { data, message } = await retainedsAPI.update({
            id: this.id,
            data: newData,
          });

          this.formData = data;
          this.$bfNotify({ title: 'Actualizado', message, type: 'success' });
        } catch ({ errors }) {
          this.formErrors = errors;
          this.$bfNotify({
            title: 'Error',
            message: 'Existe un error con tus datos',
            type: 'error',
          });
        }
      }
    },
  },

  computed: {
    ...mapState({ tasadorId: ({ auth }) => get(auth, ['user', 'tasador_id']) }),
    isEditing() {
      return !!this.id;
    },

    pageTitle() {
      return this.isEditing
        ? `Retenido del encargo: ${this.formData.encargo_codigo || ''}`
        : 'Crear Retenido';
    },
  },

  components: {
    LoadingIndicator,
    PageWrap,
    RetainedForm,
  },
};
</script>
